import type * as Types from 'app/types/graphql';

export type PlanSelectFragment = Pick<
  Types.Plan,
  | 'id'
  | 'name'
  | 'displayName'
  | 'priority'
  | 'isTrial'
  | 'basePrice'
  | 'billingCycle'
  | 'deprecated'
  | 'conditions'
  | 'createdAt'
  | 'updatedAt'
  | 'trialDays'
>;

export type PlanEdgeSelectFragment = Pick<Types.PlanEdge, 'cursor'> & {
  node?: Types.Maybe<
    Pick<
      Types.Plan,
      | 'id'
      | 'name'
      | 'displayName'
      | 'priority'
      | 'isTrial'
      | 'basePrice'
      | 'billingCycle'
      | 'deprecated'
      | 'conditions'
      | 'createdAt'
      | 'updatedAt'
      | 'trialDays'
    >
  >;
};

export const PlanSelectFragmentDoc = `
    fragment PlanSelect on Plan {
  id
  name
  displayName
  priority
  isTrial
  basePrice
  billingCycle
  deprecated
  conditions
  createdAt
  updatedAt
  trialDays
}
    `;
export const PlanEdgeSelectFragmentDoc = `
    fragment PlanEdgeSelect on PlanEdge {
  cursor
  node {
    ...PlanSelect
  }
}
    `;
